import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Frequency } from '@iss/libs/graphql';
import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'recurrenceScheduleFrequency', pure: false, standalone: true })
export class RecurrenceScheduleFrequencyPipe implements PipeTransform, OnDestroy {
  private readonly translatePipe: TranslatePipe;

  public constructor(
    translateService: TranslateService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    this.translatePipe = new TranslatePipe(translateService, changeDetectorRef);
  }

  public transform(value: Frequency | null | undefined): string {
    return this.translatePipe.transform(
      value ? `iss-wo-common.recurrence-schedule.frequency.${ value }` : '',
    ) as string;
  }

  public ngOnDestroy(): void {
    this.translatePipe.ngOnDestroy();
  }
}
